import {Component, Inject} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {HealthEvent} from "@core/models/HealthEvent";
import {DialogData} from "@core/interfaces/dialog-data";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionModule} from "@angular/material/core";
import {HealthEventService} from "@core/http/table-data-services/healthEvent.service";
import {REGEX} from "@shared/utils/regex.constants";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-health-event-create-edit',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDatepickerModule,
    MatSelectModule,
    MatOptionModule,
    MatDialogClose,
    NgIf
  ],
  templateUrl: './health-event-create-edit.component.html',
  styleUrl: './health-event-create-edit.component.scss'
})
export class HealthEventCreateEditComponent {
  action: string;
  dialogTitle: string;
  healthEventForm: UntypedFormGroup;
  healthEvent: HealthEvent;
  formControl = new UntypedFormControl('', [
    Validators.required,
  ]);

  constructor(
    public dialogRef: MatDialogRef<HealthEventCreateEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<HealthEvent>,
    public healthEventService: HealthEventService,
    private fb: UntypedFormBuilder,
  ) {
    this.action = data.action;
    if (this.action === 'edit') {
      this.dialogTitle = 'EDITAR: ' + data.entity.nombreEvento;
      this.healthEvent = data.entity;
    } else {
      this.dialogTitle = 'NUEVO EVENTO DE SALUD';
      this.healthEvent = new HealthEvent(data.entity);
    }
    this.healthEventForm = this.createContactForm();
  }

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'CAMPO REQUERIDO'
      : 'ERROR';
  }

  createContactForm(): UntypedFormGroup {
    return this.fb.group({
      idEvento: [this.healthEvent.idEvento],
      nombreEvento: [this.healthEvent.nombreEvento, [Validators.required, Validators.pattern(REGEX.user)]],
    });
  }

  submit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    this.action === 'edit'
      ? this.healthEventService.updateHealthEvent(this.healthEventForm.getRawValue())
      : this.healthEventService.addHealthEvent(this.healthEventForm.getRawValue());
  }

}
